import { Debug } from "@/util/debug";
import { FormInstance } from "antd";
const number_matching_list: (string | { [x: string]: string; name: string })[] = [
  "density",
  "hPa",
  "month",
  "percent",
  "agtron",
  "airTemp",
  "altitude",
  "bar",
  "hum",
  "mass",
  "mm",
  "moisture",
  "seq",
  "temp",
  { name: "air", input: "roastingAir" },
  { name: "hpa", input: "hPa" },
  { name: "term", input: "roastingTerm" },
  { name: "ratio", input: "percent" },
  { name: "roasting_min", input: "agtron" },
  { name: "roasting_max", input: "agtron" },
  { name: "harvest", input: "monthSelectFn" },
];
const code_matching_list: (string | { [x: string]: string; name: string; input: string })[] = [
  "process",
  "grade",
  "country",
  "variety",
  { name: "inventory_type", input: "select", code: "INVT" },
];
const text_matching_list: (string | { [x: string]: string; name: string; input: string })[] = [
  { name: "name", input: "inputFull" },
  { name: "nick", input: "inputFull" },
  { name: "etc", input: "inputFull" },
  { name: "locale", input: "inputFull" },
  { name: "variety_list", input: "varietyMulti" },
];
const select_ex_dc_list = [
  "agtron",
  "airTemp",
  "altitude",
  "bar",
  "buttonDefault",
  "buttonMinMax",
  "clickDefault",
  "coffee_country",
  "count",
  "dateDisabled",
  "datetimeDisabled",
  "defaultTimelineData",
  "density",
  "disabled",
  "distance",
  "distanceM",
  "geoMapChart",
  "getButtonProp",
  "getSettingStep",
  "getStepMarks",
  "grade",
  "greenbeanMinMaxWidth",
  "hum",
  "inputCalcClassName",
  "inputCalcWidth",
  "inputCountryClassName",
  "inputDisabled",
  "inputFullDisabled",
  "inputNumberClassName",
  "inputNumberWidth",
  "inputSelectWidth",
  "lineChart",
  "lossRate",
  "mass",
  "maxButton",
  "minButton",
  "mm",
  "mobileHidden",
  "moisture",
  "monthDisabled",
  "monthSelect",
  "monthSelectFn",
  "nivoTheme",
  "number1f",
  "number2f",
  "numberDisabled",
  "passwordDisabled",
  "process",
  "quarterDisabled",
  "radar",
  "radarInputCommon",
  "radarProp",
  "radarRate",
  "radarRateR",
  "radarSlider",
  "radarSliderR",
  "rateInput",
  "roastingAir",
  "roastingInput1",
  "roastingInput2",
  "roastingInput3",
  "roastingInputDefault",
  "roastingSlideTemp",
  "roastingTemp",
  "roastingTerm",
  "roastingTime",
  "roastingTimeWidth",
  "selectDisabled",
  "selectSearchDisabled",
  "selectSearchTag",
  "selectTag",
  "seqClassName",
  "settingBar",
  "settingFlux",
  "settingMass",
  "settingMassCalc",
  "settintStepTimer",
  "sliderInput",
  "strongLabelClassName",
  "switchText",
  "tempSettingData",
  "tempTimelineData",
  "textAreaDefault",
  "textAreaM",
  "textAreaMDefault",
  "textAreaU",
  "timeDisabled",
  "timelineChart",
  "timelineDefs",
  "timelineFill",
  "timelineInputCommon",
  "timer",
  "use",
  "useDefaultDisabled",
  "useDisabled",
  "useIcon",
  "useIconDisabled",
  "useOX",
  "useOXDisabled",
  "useText",
  "useTextDisabled",
  "variety",
  "varietyMulti",
  "waterAlk",
  "waterHard",
  "waterTds",
  "weekDisabled",
  "yearDisabled",
];
export const getMissList = (dc_list: string[]) => {
  const result = dc_list.filter((item) => {
    return !select_ex_dc_list.includes(item) && !dc_list.includes;
  });
  return result;
};
const dc_list = [
  "at",
  "by",
  "by_admin",
  "cupRadar",
  "date",
  "datetime",
  "display_user",
  "display_user_admin",
  "edit",
  "edit_admin",
  "hPa",
  "hidden",
  "hourTimer",
  "image",
  "input",
  "inputFull",
  "inputSearch",
  "link",
  "month",
  "number",
  "password",
  "percent",
  "quarter",
  "rate",
  "rgst",
  "rgst_admin",
  "select",
  "selectCountry",
  "selectMulti",
  "selectSearch",
  "selectSearchMulti",
  "seq",
  "seqYear",
  "slider",
  "switchIcon",
  "temp",
  "textArea",
  "time",
  "useDefault",
  "week",
  "year",
];
export const getDcOptions = (list?: string[]) => {
  if (list) {
    return list.map((item) => {
      return { label: item, value: item, label_str: item };
    });
  } else {
    return dc_list.map((item) => {
      return { label: item, value: item, label_str: item };
    });
  }
};
const matcingListCheckStr = (key: string, item: string, laststr_arr: string[]) => {
  return laststr_arr.some((laststr) => {
    // if (key === "code_name_kr" && item === "variety_list") {
    //   Debug(key + "," + item + "," + laststr);
    // }
    return (key.indexOf(item) > -1 && key.indexOf(laststr)) === key.length - laststr.length;
  });
};

const matcingListCheck = (
  key: string,
  list: (string | { [x: string]: string; name: string })[],
  laststr?: string | string[]
) => {
  const laststr_arr = laststr ? (typeof laststr === "string" ? [laststr] : laststr) : undefined;
  let check_obj: { [x: string]: string; name: string } = {
    name: "",
  };
  const check = list.some((item) => {
    if (typeof item === "string") {
      if (
        (key.indexOf("_" + item) > -1 && key.indexOf("_" + item) === key.length - (item.length + 1)) ||
        (laststr_arr && matcingListCheckStr(key, item, laststr_arr))
      ) {
        check_obj.name = item;
        return true;
      }
    } else {
      if (
        (key.indexOf("_" + item) > -1 && key.indexOf("_" + item.name) === key.length - (item.name.length + 1)) ||
        (laststr_arr !== undefined && matcingListCheckStr(key, item.name, laststr_arr))
      ) {
        check_obj = { ...item };
        return true;
      }
    }
    return false;
  });
  if (check) {
    return check_obj;
  } else {
    return undefined;
  }
};
export const getCheckData = (data: any) => {
  const default_list: string[] = ["LIST", "READ", "CREATE", "UPDATE", "EXCEL_IN", "EXCEL_UP"];
  const pri_key: string[] = [];
  const pri_key_list: string[] = ["LIST", "READ"];
  const use_list: string[] = ["READ", "CREATE", "UPDATE", "EXCEL_IN", "EXCEL_UP"];
  const rgst_list: string[] = ["READ", "CREATE", "EXCEL_IN"];
  const edit_list: string[] = ["READ", "CREATE", "UPDATE", "EXCEL_IN", "EXCEL_UP"];
  let seq_i = -1;
  const check_data = data
    ? data.map((item: any, index: number) => {
        const key = item.COLUMN_NAME as string;
        let COLUMN_TYPE = "input";
        let COLUMN_CODE_SELECT: string | null | undefined = null;
        const length = item.CHARACTER_MAXIMUM_LENGTH;
        const temp_obj = { ...item, IS_COMMENT: item.COLUMN_COMMENT ? ["YES"] : [], CHECK_LIST: default_list };

        switch (key) {
          case "edit_at":
          case "rgst_at":
            COLUMN_TYPE = "";
            break;
          case "rgst_by":
            COLUMN_TYPE = "rgst";
            break;
          case "edit_by":
            COLUMN_TYPE = "edit";
            break;
          case "text":
            COLUMN_TYPE = "textArea";
            break;
          default:
            switch (item.DATA_TYPE) {
              case "int":
                if (key.indexOf("_seq") === key.length - 4) {
                  if (item.COLUMN_KEY === "PRI" || item.EXTRA === "auto_increment") {
                    COLUMN_TYPE = "seq";
                  } else {
                    COLUMN_TYPE = "select";
                  }
                } else if (key.indexOf("_year") === key.length - 5) {
                  COLUMN_TYPE = "year";
                } else {
                  const check = matcingListCheck(key, number_matching_list, ["_min", "_max"]);
                  COLUMN_TYPE = check ? (check.input ? check.input : check.name) : "number";
                  COLUMN_CODE_SELECT = check?.code ?? null;
                }
                break;
              case "tinyint":
                COLUMN_TYPE = "useDefault";
                break;
              case "timestamp":
                COLUMN_TYPE = "datetime";
                break;
              case "text":
                COLUMN_TYPE = "textArea";
                break;
              case "varchar":
                if (key.indexOf("_auth") === key.length - 5) {
                  COLUMN_TYPE = "selectSearchMulti";
                } else {
                  if (length == 8) {
                    if (key.indexOf("_date") === key.length - 5) {
                      COLUMN_TYPE = "date";
                    }
                  } else if (length == 45) {
                    const check = matcingListCheck(key, code_matching_list, "_code");
                    COLUMN_TYPE = check ? (check.input ? check.input : check.name) : "select";

                    // if (key === "roasting_inventory_type") {
                    //   Debug(key, check);
                    // }

                    COLUMN_CODE_SELECT = check?.code ?? null;
                  } else if (length >= 100) {
                    const check = matcingListCheck(key, text_matching_list);
                    if (check) {
                      COLUMN_TYPE = check.input ?? check.name;
                      COLUMN_CODE_SELECT = check?.code ?? null;
                    } else {
                      if (key.indexOf("_list") === key.length - 5) {
                        COLUMN_TYPE = "selectSearchMulti";
                      } else if (length >= 500) {
                        COLUMN_TYPE = "textArea";
                      }
                    }
                  }
                  break;
                }

              //DATA_TYPE,ORDINAL_POSITION,COLUMN_DEFAULT,IS_NULLABLE,CHARACTER_MAXIMUM_LENGTH,COLUMN_KEY,EXTRA,COLUMN_COMMENT
            }
            break;
        }

        if (item.COLUMN_KEY === "PRI") {
          if (item.EXTRA === "auto_increment") {
            seq_i = index;
          }
          pri_key.push(key);
          return { ...temp_obj, CHECK_LIST: pri_key_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
        } else if (key === "rgst_at" || key === "rgst_by") {
          return { ...temp_obj, CHECK_LIST: rgst_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
        } else if (key === "edit_at" || key === "edit_by") {
          return { ...temp_obj, CHECK_LIST: edit_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
        } else {
          if (key.indexOf("_use") === key.length - 4) {
            COLUMN_TYPE = "use";
            return { ...temp_obj, CHECK_LIST: use_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
          } else if (key.indexOf("_desc") === key.length - 5) {
            return { ...temp_obj, CHECK_LIST: use_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
          } else {
            return { ...temp_obj, CHECK_LIST: default_list, COLUMN_TYPE, COLUMN_CODE_SELECT };
          }
        }
      })
    : data;
  if (pri_key.length > 1) {
    pri_key_list.push("CREATE");
    pri_key_list.push("EXCEL");
  } else if (seq_i > -1) {
    check_data[seq_i].COLUMN_TYPE = "seq";
  }
  return { check_data, pri_key };
};
export const getFormValues = (
  form: FormInstance | undefined,
  list: string[],
  join?: Record<string, string> | string[] | boolean,
  joinStr?: string
) => {
  if (form) {
    const values = form.getFieldsValue(list);
    const join_str = joinStr ?? ",";
    if ((typeof join === "boolean" && join) || (join !== undefined && typeof join !== "boolean")) {
      if (join instanceof Array) {
        join.forEach((item) => {
          if (values[item] && values[item] instanceof Array) {
            const str = values[item].join(join_str);
            values[item] = str;
          }
        });
      } else {
        Object.keys(join).forEach((item) => {
          if (values[item] && values[item] instanceof Array) {
            const str = values[item].join(typeof join !== "boolean" ? join[item] ?? "," : ",");
            values[item] = str;
          }
        });
      }
    }
    list.forEach((item) => {
      if (values[item] === undefined || (values[item] !== undefined && values[item] === "")) {
        delete values[item];
      }
    });
    return values;
  } else {
    return {};
  }
};
export const setFormValues = (form: FormInstance | undefined, values: any) => {
  if (form) {
    form.setFieldsValue(values);
  }
};
